import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {},
    score: {},
    toolIcon: {},
  }),
  { name: 'ScoredTextField' }
);
